export function rewardStages(campaign) {
  return [
    {
      key: 'registration',
      inviterMinor: campaign.inviterRegistrationRewardMinor || 0,
      inviteeMinor: campaign.inviteeRegistrationRewardMinor || 0,
    },
    {
      key: 'certification',
      inviterMinor: campaign.inviterRewardMinor || 0,
      inviteeMinor: campaign.inviteeRewardMinor || 0,
    },
  ];
}
